"use strict";

/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.write = void 0;
var Codec = require("./../../io/codec");
/**
 * Write a {@link BinaryValue} update constraint to the stream
 */
function write(bos, value) {
  Codec.writeBytes(bos, value.getBytes().asBuffer());
}
exports.write = write;